import {
  Heading,
  Stat,
  Button,
  Flex,
  Link,
  Table,
  Stack,
  Spinner,
  IconButton,
  ButtonGroup,
} from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";
import { useSession } from "../../hooks/useSession";
import { useCustomerList } from "../../hooks/useCustomers";
import { Pencil } from "lucide-react";

export default function CustomerPage() {
  useSession();

  const { data, isLoading } = useCustomerList();

  return (
    <>
      <Stack>
        <Heading as="h1" mb={4}>
          Kundeliste
        </Heading>
        <Stack direction="row">
          <ButtonGroup>
            <Link asChild>
              <ReactRouterLink to="/customers/create/">
                <Button variant="solid" colorPalette="blue">
                  Lag ny kunde
                </Button>
              </ReactRouterLink>
            </Link>
            <Link asChild>
              <ReactRouterLink to="/customers/groups/">
                <Button variant="solid" colorPalette="purple">
                  Kundegrupper
                </Button>
              </ReactRouterLink>
            </Link>
          </ButtonGroup>
        </Stack>
        <Flex alignItems="center">
          <Stat.Root my={4}>
            <Stat.Label>Antall kunder</Stat.Label>
            <Stat.ValueText>{data?.length || 0}</Stat.ValueText>
          </Stat.Root>
        </Flex>
        {isLoading && <Spinner />}
        <Table.ScrollArea>
          <Table.Root>
            <Table.Header>
              <Table.Row>
                <Table.ColumnHeader>ID</Table.ColumnHeader>
                <Table.ColumnHeader>Navn</Table.ColumnHeader>
                <Table.ColumnHeader>E-post</Table.ColumnHeader>
                <Table.ColumnHeader>Organisasjonsnummer</Table.ColumnHeader>
                <Table.ColumnHeader>Handlinger</Table.ColumnHeader>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!isLoading &&
                data?.map((customer) => (
                  <Table.Row key={customer.customerNumber}>
                    <Table.Cell>{customer.customerNumber}</Table.Cell>
                    <Table.Cell>{customer.name}</Table.Cell>
                    <Table.Cell>{customer.email}</Table.Cell>
                    <Table.Cell>{customer.orgNumber}</Table.Cell>
                    <Table.Cell width={100} p={0}>
                      <Stack
                        direction="row"
                        gap={0}
                        p={0}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Link asChild>
                          <ReactRouterLink
                            to={`/customers/${customer.customerNumber}/edit/`}
                          >
                            <IconButton
                              size="lg"
                              colorPalette="blue"
                              variant="ghost"
                              aria-label="Endre"
                            >
                              <Pencil />
                            </IconButton>
                          </ReactRouterLink>
                        </Link>
                      </Stack>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table.Root>
        </Table.ScrollArea>
      </Stack>
    </>
  );
}
